import { Theme } from '../../types';
import { CSSObject } from '@emotion/react';
import { MOBILE_MEDIA_QUERY, DESKTOP_MEDIA_QUERY } from '../../utils/breakpoints';

export const layoutStyles = (theme: Theme): { [key: string]: Record<string, CSSObject | string | number> } => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: theme.colorSchema.colors.secondaryBackground,
    position: 'relative',
  },
  subContainer: {
   marginTop: '60px', // To account for the fixed header height
  },
  header: {
    position: 'fixed',
    top: 0,
    height: '60px',
    width: '100%',
    backgroundColor: theme.colorSchema.colors.primary,
    zIndex: 1000,
  },
  // Base position/size live here (not just on sidebarOpen) so the sidebar is
  // consistently laid out regardless of open state - only the slide
  // transform changes.
  sidebar: {
    transition: 'transform 0.3s ease',
    transform: 'translateX(-100%)', // Hidden by default
    width: '220px',
    height: 'calc(100vh - 60px)',
    position: 'fixed',
    top: '60px',
    left: 0,
    zIndex: 900,
    boxSizing: 'border-box',
    overflowY: 'auto',
    backgroundColor: theme.colorSchema.colors.mainBackground,
    boxShadow: `0px 2px 10px rgba(0, 0, 0, 0.1)`,
    padding: '20px',
  },
  sidebarOpen: {
    transform: 'translateX(0)', // Slide in when menu is open
  },
  // Only rendered on mobile, and only while the sidebar is open - tapping it
  // closes the sidebar instead of it pushing page content around.
  backdrop: {
    display: 'none',
    [`@media ${MOBILE_MEDIA_QUERY}`]: {
      display: 'block',
      position: 'fixed',
      top: '60px',
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      zIndex: 800,
    },
  },
  mainContent: {
    transition: 'left 0.3s ease, width 0.3s ease',
    flexGrow: 1,
    // bottom: 0 (with top: 60px) caps the box's height at the viewport, so
    // overflowY can actually scroll its content instead of the box just
    // growing taller than the screen with nothing to reveal what's below it.
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'fixed',
    top: '60px',
    bottom: 0,
    left: 0,
    width: '100%',
    boxSizing: 'border-box',
  },
  // Applied together with mainContent (not swapped for it) so the base
  // fixed/position rules above are never lost. Only pushes content over on
  // screens wide enough for the sidebar to sit beside it instead of on top.
  // Note: a plain margin-left won't work here - mainContent is
  // position:fixed with width:100% (resolved against the viewport, not its
  // margin box), so a margin only shifts the box right without shrinking
  // it, pushing its right edge off-screen. left + width must move together.
  mainContentWithSidebar: {
    [`@media ${DESKTOP_MEDIA_QUERY}`]: {
      // Matches sidebar's own width above - a mismatch here leaves a bare
      // strip of page background between the sidebar and the content.
      left: '220px',
      width: 'calc(100% - 220px)',
    },
  },
});
